module.exports = __webpack_public_path__ + "img/State_of_Repair_vs_Occupancy.871c1f05.jpg";